<template>
  <div class="flex justify-between align-center globalTip size12 color666" v-if="msgList.length>0">
    <div class="flex align-center">
      <span class="colorOrange">共{{ msgList.length }}条通知</span>
      <gj-button type="text" class="color666" :class="{'color999':active===0}" :disabled="active===0" @click="previous">
        <i class="el-icon-arrow-left"></i>
          上一条
      </gj-button>
      <gj-button type="text" class="color666" :class="{'color999':active+1===msgList.length}" :disabled="active+1===msgList.length" @click="next">
        下一条
        <i class="el-icon-arrow-right"></i>
      </gj-button>
      <span class="msg-tit">{{ msgList[active].message }}</span>
      <!-- routerMsg('/message/message-center', {type: active}) -->
       <gj-button v-if="msgList[active].msgType === 'ORDER_GIFT' || msgList[active].msgType === 'EMAIL_GIFT' || msgList[active].msgType === 'G_POINT_GIFT'" @click="routerMsg('/message/message-center', {type: 'account'})" type="text"> 立即处理
          <i class="el-icon-arrow-right"></i></gj-button>
      <gj-link v-else route-to="/system/market" @click="msgsGlobalRead">
        <div>
          立即处理
          <i class="el-icon-arrow-right"></i>
        </div>
      </gj-link>
    </div>
    <gj-button
        type="iconfont"
        :iconfont="'iconguanbi-da'"
        class="color999 size12"
        style="transform:scale(.8)"
        @click="msgsGlobalRead"
    ></gj-button>
  </div>
</template>

<script>
import {msgsGlobal, msgsGlobalRead} from "@/api/dashboard";
import {USER_SET_ISMSGSGLOBAL} from "@/store/mutation-types";

export default {
  name: "global-message",
  data() {
    return {
      msgList: [],
      active: 0,
      // pathOption:{
      //   ORDER_GIFT:'/system/market',// 赠送订单量
      //   SHOP_EMAIL_FAIL:'/system/market',// 邮箱授权异常
      //   SHOP_ADS_FAIL:'/system/market',// 广告授权异常
      //   SHOP_AUTH_EXPIRES:'/system/market',// 店铺授权异常
      // }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        // 全局消息通知栏
        this.msgsGlobal()
      }
    }
  },
  methods: {
    routeTo(){

    },
    previous(){
      this.active-=1
    },
    next(){
      this.active+=1
    },
    msgsGlobal() {
      msgsGlobal().then(res => {
        this.msgList = res.result;
        this.$store.commit(USER_SET_ISMSGSGLOBAL, this.msgList.length > 0);
      })
    },
    msgsGlobalRead(){
      msgsGlobalRead(this.msgList[this.active])
      this.msgList.splice(this.active,1)
      if(this.active>0){
        this.active-=1;
      }
      this.$store.commit(USER_SET_ISMSGSGLOBAL, this.msgList.length > 0);
    },
     // 路由跳转
    routerMsg(path, query) {
      this.msgsGlobalRead();
      this.$router.push({path: path, query: query});
    },
  }
}
</script>

<style scoped lang="scss">
.globalTip {
  margin: 8px 16px 0;
  padding: 0 16px;
  height: 24px;
  background-color: #FFF5ED;
  border: 1px solid #F1924E;
  border-radius: 4px;

  .colorOrange {
    margin: 0 10px 0 6px;
  }

  .msg-tit {
    margin: 0 8px 0 16px;
  }
}
</style>